module.exports = __webpack_public_path__ + "img/hydrodips.c28a5557.jpg";